import type { TDisconnectedStatus } from '../internetConnection.t';
import { Spinner } from 'react-bootstrap';
import { memo } from 'react';
import BinIcon from '../../../components/icon/IconWrapped';
import { CONNECTION_STATUS_NAMES } from '../internetConnectionConstants';

const ConnectionStatusIcon = ({ status }: { status: TDisconnectedStatus }) => {
    switch (status) {
        case CONNECTION_STATUS_NAMES.DISCONNECTED:
            return <BinIcon name={'IcDisconnect'}/>;
        case CONNECTION_STATUS_NAMES.CONNECTING:
            return <Spinner animation="border" size="sm" />;
        default:
            return <BinIcon name={'IcConnect'}/>;
    }
}

export default memo(ConnectionStatusIcon);
